import React from 'react'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { PayrollRunDataUpdatedDocument } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useSubscription } from 'modules/core/hooks/useSubscription'
import i18n from 'modules/core/lib/i18n'

interface Props {
  payrollRunId: string
  onRefresh: () => void
}

function PayrollRunDataUpdatedInfo({ payrollRunId, onRefresh }: Props) {
  const [hasNewPayrollData, setHasNewPayrollData] = React.useState<boolean>(false)
  const [message, setMessage] = React.useState<string>('')
  const { data: processPayrollRunDataUpdated } = useSubscription(PayrollRunDataUpdatedDocument)

  const icon = <Icon.Medium icon="lightbulb" color="viridian1000" />

  useUnsafeEffect(() => {
    const importedDataSubscription =
      processPayrollRunDataUpdated?.compensationsPayrollRunDataUpdated?.payrollRun

    if (importedDataSubscription?.id === payrollRunId) {
      defineMessage(
        processPayrollRunDataUpdated?.compensationsPayrollRunDataUpdated?.payrollRun?.type
      )
      setHasNewPayrollData(true)
    }
  }, [processPayrollRunDataUpdated, payrollRunId])

  const defineMessage = (type: string | undefined) => {
    if (!type) return

    if (type === 'import_finished') {
      setMessage(i18n.t('compensations.PayrollRunDataUpdatedInfo.import_finished'))
    } else if (type === 'import_deleted') {
      setMessage(i18n.t('compensations.PayrollRunDataUpdatedInfo.import_deleted'))
    } else {
      setMessage('')
    }
  }

  const onRefreshButtonClick = () => {
    onRefresh()
    setHasNewPayrollData(false)
  }

  return (
    hasNewPayrollData && (
      <Alert color="info">
        <Box
          flexDirection="row"
          gap="s12"
          justifyContent="spaceBetween"
          alignItems="center"
          width="full"
        >
          <Box flexDirection="row" alignItems="center" gap="s12">
            {icon}
            <Text.Normal color="grey1000">{message}</Text.Normal>
          </Box>
          <Box flexDirection="row" alignItems="center" gap="s12">
            <F0Button
              onClick={onRefreshButtonClick}
              variant="outline"
              label={i18n.t('compensations.PayrollRunDataUpdatedInfo.refresh')}
            />
          </Box>
        </Box>
      </Alert>
    )
  )
}

export default PayrollRunDataUpdatedInfo
